/* ============================================================
   VIZVOICE THEME — theme.js
   Vanilla JS. No dependencies.
   ============================================================ */

'use strict';

// ── Color name → CSS color value (Shopify/Printful standard palette) ──
// Shared by the PDP variant selector and the Quick Add popover.
const COLOR_MAP = {
  'white':          '#ffffff',
  'black':          '#1a1a1a',
  'navy':           '#1f305e',
  'royal blue':     '#4169e1',
  'carolina blue':  '#7eb6d4',
  'light blue':     '#add8e6',
  'sky blue':       '#87ceeb',
  'sport grey':     '#9da5a9',
  'dark grey':      '#555',
  'ash':            '#b2b2b2',
  'natural':        '#f5f0e6',
  'sand':           '#c8b89a',
  'cream':          '#fffdd0',
  'heather':        '#c0b8d8',
  'red':            '#cc2929',
  'maroon':         '#800000',
  'cardinal red':   '#9b1d20',
  'forest green':   '#228b22',
  'military green': '#4b5320',
  'olive':          '#808000',
  'pink':           '#ffb6c1',
  'light pink':     '#ffb6c1',
  'purple':         '#800080',
  'gold':           '#ffd700',
  'orange':         '#ff7f00',
  'brown':          '#8b4513',
  'charcoal':       '#36454f',
};
function swatchColor(name) {
  return COLOR_MAP[name.toLowerCase()] || '#ccc';
}

// ── Strip leading emoji from collection titles ─────────────
(function () {
  document.querySelectorAll('.js-strip-emoji').forEach(function (el) {
    el.textContent = el.textContent.replace(/^[\p{Emoji_Presentation}\p{Extended_Pictographic}][\uFE0F\u200D\u20E3]* /u, '').trim();
  });
})();

// ── Header search toggle ───────────────────────────────────
(function () {
  const toggleBtn = document.querySelector('.js-search-toggle');
  const overlay   = document.getElementById('header-search-overlay');
  const input     = document.getElementById('header-search-input');
  const closeBtn  = document.querySelector('.js-search-close');
  if (!toggleBtn || !overlay) return;

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    if (input) { input.focus(); }
  }
  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
  }

  toggleBtn.addEventListener('click', function () {
    overlay.classList.contains('is-open') ? closeSearch() : openSearch();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });
})();

// ── Sticky header ──────────────────────────────────────────
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── Mobile menu ────────────────────────────────────────────
(function () {
  const toggle = document.querySelector('.menu-toggle');
  const menu   = document.getElementById('mobile-menu');
  const close  = document.querySelector('.mobile-menu__close');
  if (!toggle || !menu) return;

  function openMenu() {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    toggle.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', openMenu);
  if (close) close.addEventListener('click', closeMenu);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
})();

// ── Product gallery ────────────────────────────────────────
(function () {
  const gallery = document.querySelector('.product-gallery');
  if (!gallery) return;

  const mainImg = gallery.querySelector('.product-gallery__main img');
  const thumbs  = gallery.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt || '';
      if (mainImg && src) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        mainImg.alt = alt;
      }
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
  });

  // Swipe op de hoofdfoto (mobiel) → volgende/vorige afbeelding
  const main = gallery.querySelector('.product-gallery__main');
  if (main && thumbs.length > 1) {
    let startX = 0, startY = 0;
    main.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const list = Array.from(thumbs);
      const cur = list.findIndex(t => t.classList.contains('is-active'));
      const next = (cur + (dx < 0 ? 1 : -1) + list.length) % list.length;
      list[next].click();
    }, { passive: true });
  }
})();

// ── Image zoom lightbox ────────────────────────────────────
(function () {
  const trigger  = document.querySelector('[data-zoom-trigger]');
  const modal    = document.getElementById('zoom-modal');
  if (!trigger || !modal) return;

  const backdrop = modal.querySelector('.zoom-modal__backdrop');
  const closeBtn = modal.querySelector('.zoom-modal__close');
  const prevBtn  = modal.querySelector('.zoom-modal__prev');
  const nextBtn  = modal.querySelector('.zoom-modal__next');
  const zoomImg  = modal.querySelector('.zoom-modal__img');
  const thumbs   = document.querySelectorAll('.product-gallery__thumb');

  // Build image list from thumbs, or fall back to the single main image
  let images = [];
  if (thumbs.length > 0) {
    thumbs.forEach(t => images.push({ src: t.dataset.src, alt: t.dataset.alt || '' }));
  } else {
    const mainImg = document.getElementById('main-product-img');
    if (mainImg) images.push({ src: mainImg.src, alt: mainImg.alt });
  }

  let currentIndex = 0;

  function getActiveIndex() {
    let idx = 0;
    thumbs.forEach((t, i) => { if (t.classList.contains('is-active')) idx = i; });
    return idx;
  }

  function showImage(index) {
    if (images.length === 0) return;
    currentIndex = (index + images.length) % images.length;
    const img = images[currentIndex];
    zoomImg.src = img.src;
    zoomImg.alt = img.alt;

    // Sync main gallery image
    const mainImg = document.getElementById('main-product-img');
    if (mainImg) {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = img.src;
      mainImg.alt = img.alt;
    }
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === currentIndex));

    // Hide nav buttons when only 1 image
    const showNav = images.length > 1;
    if (prevBtn) prevBtn.style.display = showNav ? '' : 'none';
    if (nextBtn) nextBtn.style.display = showNav ? '' : 'none';
  }

  function openZoom() {
    if (images.length === 0) return;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    showImage(getActiveIndex());
  }

  function closeZoom() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', openZoom);
  if (backdrop) backdrop.addEventListener('click', closeZoom);
  if (closeBtn) closeBtn.addEventListener('click', closeZoom);
  if (prevBtn) prevBtn.addEventListener('click', e => { e.stopPropagation(); showImage(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', e => { e.stopPropagation(); showImage(currentIndex + 1); });

  document.addEventListener('keydown', e => {
    if (modal.style.display === 'none') return;
    if (e.key === 'Escape') closeZoom();
    if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (e.key === 'ArrowRight') showImage(currentIndex + 1);
  });

  // Touch swipe support
  let touchStartX = 0;
  modal.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  modal.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) showImage(dx < 0 ? currentIndex + 1 : currentIndex - 1);
  });
})();

// ── Variant Selector (color + size, data-driven from product JSON) ──
(function () {
  const productJsonEl = document.getElementById('product-json');
  if (!productJsonEl) return;

  const product  = JSON.parse(productJsonEl.textContent);
  const variants = product.variants;
  const options  = product.options;

  const colorSwatchesEl = document.getElementById('color-swatches');
  const sizeOptionsEl   = document.getElementById('size-options');
  const colorLabelEl    = document.querySelector('[data-color-label]');
  const sizeInput       = document.querySelector('[name="id"]');
  const atcBtn          = document.querySelector('.btn--atc:not(.sticky-atc__btn)');

  const colorIdx = options.indexOf('Color') >= 0 ? options.indexOf('Color') : options.indexOf('Colour');
  const sizeIdx  = options.indexOf('Size');

  let selectedColor = null;
  let selectedSize  = null;

  const colorKey = i => 'option' + (i + 1);

  function findVariant(color, size) {
    return variants.find(v => {
      const cMatch = colorIdx < 0 || v[colorKey(colorIdx)] === color;
      const sMatch = sizeIdx  < 0 || v[colorKey(sizeIdx)]  === size;
      return cMatch && sMatch;
    });
  }

  const isAvail = v => v.available;
  const anyAvailable = variants.some(isAvail);

  function updateAtc() {
    if (!atcBtn) return;
    const addText      = atcBtn.dataset.addText || 'Add to Cart';
    const colorPicked  = colorIdx < 0 || selectedColor !== null;
    const sizePicked   = sizeIdx  < 0 || selectedSize  !== null;

    if (!anyAvailable) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Sold Out';
      return;
    }
    if (!colorPicked || !sizePicked) {
      atcBtn.disabled = false;
      atcBtn.textContent = 'Select Options';
      return;
    }
    const v = findVariant(selectedColor, selectedSize);
    if (!v) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; return; }
    if (isAvail(v)) {
      atcBtn.disabled = false;
      atcBtn.textContent = addText;
      if (sizeInput) sizeInput.value = v.id;
    } else {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Sold Out';
    }
  }

  function buildSizeButtons() {
    if (!sizeOptionsEl) return;
    const sizes = sizeIdx >= 0
      ? [...new Set(variants.map(v => v[colorKey(sizeIdx)]))]
      : [];
    sizeOptionsEl.innerHTML = '';
    sizes.forEach(size => {
      const v = findVariant(selectedColor, size);
      const available = v ? isAvail(v) : false;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'size-btn' + (selectedSize === size ? ' is-active' : '');
      btn.textContent = size;
      btn.disabled = !available;
      btn.setAttribute('aria-label', size + (available ? '' : ' — sold out'));
      btn.addEventListener('click', () => {
        sizeOptionsEl.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedSize = size;
        updateAtc();
      });
      sizeOptionsEl.appendChild(btn);
    });
  }

  // Build color swatches — use variant featured_image if available, else CSS color
  if (colorSwatchesEl && colorIdx >= 0) {
    const colors = [...new Set(variants.map(v => v[colorKey(colorIdx)]))];
    colors.forEach(color => {
      const firstVariant = variants.find(v => v[colorKey(colorIdx)] === color);
      const img = firstVariant && firstVariant.featured_image ? firstVariant.featured_image.src : null;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'color-swatch';
      btn.title = color;
      btn.setAttribute('aria-label', color);
      if (img) {
        const thumb = img.split('?')[0] + '?width=60&height=60&crop=center';
        btn.style.cssText = `background-image:url(${thumb});background-size:cover;background-position:center;border:2px solid rgba(0,0,0,.1);`;
      } else {
        const hex = swatchColor(color);
        const isDark = parseInt(hex.replace('#',''), 16) < 0x888888;
        btn.style.cssText = `background:${hex};border:${hex === '#ffffff' ? '1px solid rgba(0,0,0,.2)' : '1px solid rgba(0,0,0,.08)'};`;
      }
      btn.addEventListener('click', () => {
        colorSwatchesEl.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedColor = color;
        if (colorLabelEl) colorLabelEl.textContent = color;
        buildSizeButtons();
        updateAtc();
      });
      colorSwatchesEl.appendChild(btn);
    });

    // Auto-select first color
    const first = colorSwatchesEl.querySelector('.color-swatch');
    if (first) {
      first.classList.add('is-active');
      selectedColor = colors[0];
      if (colorLabelEl) colorLabelEl.textContent = colors[0];
    }
  }

  buildSizeButtons();
  updateAtc();

  // Guard: shake size buttons if none selected
  if (atcBtn) {
    atcBtn.addEventListener('click', e => {
      const colorPicked = colorIdx < 0 || selectedColor !== null;
      const sizePicked  = sizeIdx  < 0 || selectedSize  !== null;
      if (!colorPicked || !sizePicked) {
        e.preventDefault();
        const tip = document.querySelector('[data-pick-size-tip]');
        if (sizeOptionsEl) {
          sizeOptionsEl.querySelectorAll('.size-btn').forEach(b => b.classList.add('shake'));
          setTimeout(() => sizeOptionsEl.querySelectorAll('.size-btn').forEach(b => b.classList.remove('shake')), 400);
        }
        if (tip) { tip.style.display = 'block'; setTimeout(() => tip.style.display = '', 2000); }
      }
    });
  }
})();

// ── Sticky ATC (mobile) ────────────────────────────────────
(function () {
  const atcArea  = document.querySelector('.atc-area');
  const stickyBar = document.querySelector('.sticky-atc');
  const stickyBtn = document.querySelector('.sticky-atc__btn');
  const mainBtn   = document.querySelector('.btn--atc:not(.sticky-atc__btn)');
  if (!atcArea || !stickyBar) return;

  const observer = new IntersectionObserver(([entry]) => {
    stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
  }, { threshold: 0 });
  observer.observe(atcArea);

  // Sticky btn triggers main form submit
  if (stickyBtn && mainBtn) {
    stickyBtn.addEventListener('click', () => mainBtn.click());
  }
})();

// ── Accordion ──────────────────────────────────────────────
(function () {
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const isOpen = item.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.accordion__item').forEach(i => i.classList.remove('is-open'));
      // Toggle clicked
      if (!isOpen) item.classList.add('is-open');
    });
  });
})();

// ── POD shipping toggle ────────────────────────────────────
(function () {
  var trigger = document.querySelector('.pod-shipping__trigger');
  if (!trigger) return;
  trigger.addEventListener('click', function () {
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', !expanded);
    trigger.nextElementSibling.classList.toggle('is-open', !expanded);
  });
})();

// ── Size guide modal ───────────────────────────────────────
(function () {
  const trigger  = document.querySelector('[data-size-guide-trigger]');
  const modal    = document.getElementById('size-guide-modal');
  if (!trigger || !modal) return;

  const backdrop = modal.querySelector('.modal__backdrop');
  const closeBtn = modal.querySelector('.modal__close');

  trigger.addEventListener('click', e => { e.preventDefault(); modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  const close = () => { modal.classList.remove('is-open'); document.body.style.overflow = ''; };
  if (backdrop) backdrop.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
})();

// ── Gift panel (Send as a Gift) ────────────────────────────
(function () {
  const toggleBtn  = document.querySelector('[data-gift-toggle]');
  const panel      = document.getElementById('gift-panel');
  const textarea   = document.getElementById('gift-message-textarea');
  const counter    = document.getElementById('gift-char-count');
  const addBtn     = document.getElementById('gift-add-btn');
  const msgInput   = document.getElementById('gift-message-input');
  const flagInput  = document.getElementById('gift-flag-input');
  const form       = document.getElementById('product-form');

  if (!toggleBtn || !panel) return;

  toggleBtn.addEventListener('click', () => {
    const isOpen = panel.classList.toggle('is-open');
    panel.setAttribute('aria-hidden', String(!isOpen));
    toggleBtn.setAttribute('aria-expanded', String(isOpen));
    toggleBtn.textContent = isOpen ? 'Cancel ✕' : 'Send as a Gift →';
    if (isOpen && textarea) textarea.focus();
  });

  if (textarea && counter) {
    textarea.addEventListener('input', () => {
      counter.textContent = textarea.value.length;
    });
  }

  if (addBtn && form) {
    addBtn.addEventListener('click', () => {
      if (msgInput)  msgInput.value  = textarea ? textarea.value.trim() : '';
      if (flagInput) flagInput.value = 'true';
      // Trigger via the main submit button to preserve size-guard logic
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.click();
    });
  }
})();

// ── Gift Finder ────────────────────────────────────────────
(function () {
  const finder = document.querySelector('.gift-finder');
  if (!finder) return;

  const cta   = finder.querySelector('[data-gift-finder-cta]');
  const state = { who: null, theme: null, occasion: null };

  // Detect self mode from URL
  const isSelfMode = new URLSearchParams(window.location.search).get('for') === 'me';

  function buildUrl() {
    const tags = [];
    if (state.theme) tags.push(state.theme);
    if (state.occasion && state.occasion !== state.theme) tags.push(state.occasion);
    const base = tags.length === 0
      ? (finder.dataset.collectionUrl || '/#collection-grid')
      : '/collections/all/' + tags.join('+');
    return state.who ? base + '?who=' + encodeURIComponent(state.who) : base;
  }

  const themeLabel = finder.querySelector('[data-label-self]');

  function updateThemeLabel() {
    if (!themeLabel) return;
    if (state.who === 'myself') {
      themeLabel.textContent = themeLabel.dataset.labelSelf;
    } else if (state.who) {
      themeLabel.textContent = themeLabel.dataset.labelGift;
    }
  }

  function activatePill(pill) {
    const group = pill.dataset.group;
    finder.querySelectorAll(`.pill[data-group="${group}"]`).forEach(p => p.classList.remove('is-active'));
    pill.classList.add('is-active');
    state[group] = pill.dataset.value;
    if (group === 'who') {
      updateThemeLabel();
      // Clear occasion pre-selection when switching away from Myself
      if (pill.dataset.value !== 'myself') {
        finder.querySelectorAll('.pill[data-group="occasion"]').forEach(p => p.classList.remove('is-active'));
        state.occasion = null;
      }
    }
    if (cta) {
      cta.href = buildUrl();
    }
  }

  // Self mode setup
  if (isSelfMode) {
    // Pre-select Myself
    const myselfPill = finder.querySelector('.pill[data-group="who"][data-value="myself"]');
    if (myselfPill) activatePill(myselfPill);

    // Update step 2 label
    const themeLabel = finder.querySelector('[data-label-self]');
    if (themeLabel) themeLabel.textContent = themeLabel.dataset.labelSelf;

    // Swap occasion groups
    const giftOcc = finder.querySelector('[data-occasion-group="gift"]');
    const selfOcc = finder.querySelector('[data-occasion-group="self"]');
    if (giftOcc) giftOcc.style.display = 'none';
    if (selfOcc) {
      selfOcc.style.display = '';
      // Auto-select "I'm awesome!"
      const awesomePill = Array.from(selfOcc.querySelectorAll('.pill')).find(p => p.textContent.includes("awesome"));
      if (awesomePill) activatePill(awesomePill);
    }

    // Scroll to gift finder
    finder.closest('#gift-finder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  finder.querySelectorAll('.pill').forEach(pill => {
    pill.addEventListener('click', () => activatePill(pill));
  });
})();

// ── Cart: free shipping progress bar ──────────────────────
(function () {
  const bar       = document.querySelector('[data-fs-threshold]');
  const fill      = document.querySelector('.free-shipping-bar__fill');
  const labelEl   = document.querySelector('.free-shipping-bar__label');
  if (!fill || !bar) return;

  const threshold      = parseFloat(bar.dataset.fsThreshold || '50') * 100;
  const subtotal       = parseFloat(bar.dataset.cartSubtotal || '0');
  const itemCount      = parseInt(bar.dataset.cartItemCount || '0', 10);
  const currencySymbol = bar.dataset.currencySymbol || '$';

  const pct = Math.min(100, (subtotal / threshold) * 100);
  fill.style.width = pct + '%';

  if (labelEl) {
    if (pct >= 100) {
      labelEl.textContent = "You've unlocked free shipping!";
      labelEl.style.color = 'var(--color-secondary)';
    } else {
      const remaining = threshold - subtotal;
      if (itemCount > 0) {
        const avgItemPrice = subtotal / itemCount;
        const itemsNeeded = Math.max(1, Math.ceil(remaining / avgItemPrice));
        const itemWord = itemsNeeded === 1 ? 'item' : 'items';
        labelEl.textContent = `Add ${itemsNeeded} more ${itemWord} for free shipping`;
      } else {
        labelEl.textContent = `Add ${currencySymbol}${(remaining / 100).toFixed(2)} more for free shipping`;
      }
    }
  }
})();

// ── Checkout kiss (replaces confetti) ─────────────────────
// Click on "Checkout": big VIZVOICE kiss lips pucker → smack (synthesised Web Audio pop + "mwah")
// with a burst of hearts, then continue to /checkout. No external libraries, no audio file.
(function () {
  const checkoutBtn = document.querySelector('a[href="/checkout"]');
  if (!checkoutBtn) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function smack() {
    try {
      const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
      const ctx = new AC(); const now = ctx.currentTime + 0.42;   // in sync with the visual smack
      // "mwah": short tonal glide
      const o = ctx.createOscillator(), og = ctx.createGain();
      o.type = 'sine'; o.frequency.setValueAtTime(520, now - 0.09); o.frequency.exponentialRampToValueAtTime(980, now - 0.01); o.frequency.exponentialRampToValueAtTime(380, now + 0.07);
      og.gain.setValueAtTime(0.0001, now - 0.09); og.gain.exponentialRampToValueAtTime(0.12, now - 0.03); og.gain.exponentialRampToValueAtTime(0.0001, now + 0.09);
      o.connect(og).connect(ctx.destination); o.start(now - 0.1); o.stop(now + 0.12);
      // lip pop: band-passed noise burst
      const len = Math.floor(ctx.sampleRate * 0.08), buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
      for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3);
      const n = ctx.createBufferSource(); n.buffer = buf;
      const bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 1700; bp.Q.value = 1.1;
      const ng = ctx.createGain(); ng.gain.setValueAtTime(0.55, now); ng.gain.exponentialRampToValueAtTime(0.0001, now + 0.08);
      n.connect(bp).connect(ng).connect(ctx.destination); n.start(now);
      setTimeout(() => ctx.close(), 1200);
    } catch (err) {}
  }

  function kissOverlay() {
    const el = document.createElement('div');
    el.className = 'vv-kiss-overlay';
    el.setAttribute('aria-hidden', 'true');
    const heart = '<svg viewBox="0 0 24 22"><path d="M12 21s-7.5-4.6-10-9.3C.3 8.4 2 4.2 5.8 3.6c2.4-.4 4.5.9 6.2 3.1 1.7-2.2 3.8-3.5 6.2-3.1 3.8.6 5.5 4.8 3.8 8.1C19.5 16.4 12 21 12 21z"/></svg>';
    let hearts = '';
    for (let i = 0; i < 9; i++) {
      const ang = (-90 + (i - 4) * 26) * Math.PI / 180, dist = 120 + (i % 3) * 40;
      hearts += '<span class="vv-kiss-heart" style="--x:' + Math.round(Math.cos(ang) * dist) + 'px;--y:' + Math.round(Math.sin(ang) * dist) + 'px;--r:' + ((i - 4) * 9) + 'deg;--d:' + (i % 3) * 40 + 'ms">' + heart + '</span>';
    }
    el.innerHTML = '<div class="vv-kiss-stage"><svg class="vv-kiss-lips" viewBox="400 130 260 175">' +
      '<path d="M418 213 C 438 202, 450 156, 487 142 C 507 136, 521 148, 530 159 C 539 148, 553 136, 573 142 C 610 156, 622 202, 642 213 C 608 207, 576 199, 530 205 C 484 199, 452 207, 418 213 Z"/><path d="M418 218 C 452 214, 486 205, 530 212 C 574 205, 608 214, 642 218 C 630 257, 591 290, 530 291 C 469 290, 430 257, 418 218 Z"/>' +
      '<g fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round"><path d=\"M511 160 l -4 17\"/><path d=\"M549 160 l 4 17\"/><path d=\"M498 233 l -3 15\"/><path d=\"M530 237 l 0 17\"/><path d=\"M562 233 l 3 15\"/></g></svg>' + hearts + '</div>';
    document.body.appendChild(el);
    return el;
  }

  checkoutBtn.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || reduce) return;   // new tab / reduced motion → straight through
    e.preventDefault();
    kissOverlay();
    smack();
    setTimeout(function () { window.location.href = checkoutBtn.getAttribute('href'); }, 1300);
  });
})();

// ── Sort select (collection) ───────────────────────────────
(function () {
  const sel = document.querySelector('.sort-select');
  if (!sel) return;
  sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  });
})();

// ── Gift Finder: result bar on collection page ─────────────
(function () {
  const bar = document.querySelector('.gf-result-bar');
  if (!bar) return;

  const params  = new URLSearchParams(window.location.search);
  const who     = params.get('who');
  const tagMatch = window.location.pathname.match(/\/collections\/[^/]+\/(.+)/);
  const tags    = tagMatch ? tagMatch[1].split('+').filter(Boolean) : [];

  if (!who && tags.length === 0) return;

  const tagLabels = {
    sarcastic: 'Sarcastic', pets: 'Pets', coffee: 'Coffee', gaming: 'Gaming',
    outdoors: 'Outdoors', wine: 'Wine', nurse: 'Nurses', birthday: 'Birthday',
    'just-because': 'Just Because', holiday: 'Holiday', promotion: 'Promotion',
    'new-baby': 'New Baby', retirement: 'Retirement'
  };
  const whoLabels = {
    myself: 'For myself', friend: 'Friend', partner: 'Partner',
    parent: 'Parent', family: 'Family', colleague: 'Colleague'
  };

  function removeUrl(removeTag, removeWho) {
    const remaining = tags.filter(t => t !== removeTag);
    const base = remaining.length > 0 ? '/collections/all/' + remaining.join('+') : '/#collection-grid';
    const p = new URLSearchParams(params);
    if (removeWho) p.delete('who');
    const qs = p.toString();
    return base + (qs ? '?' + qs : '');
  }

  function pill(label, href) {
    return '<span class="gf-result-bar__tag">' + label +
      ' <a href="' + href + '" class="gf-result-bar__remove" aria-label="Remove">\u00d7</a></span>';
  }

  let html = '<a href="/#gift-finder" class="gf-result-bar__back"><i class="ph-duotone ph-sliders"></i> Adjust selection</a><div class="gf-result-bar__tags">';
  if (who) html += pill(whoLabels[who] || who, removeUrl(null, true));
  tags.forEach(function(tag) {
    const lbl = tagLabels[tag] || tag.replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    html += pill(lbl, removeUrl(tag, false));
  });
  html += '</div>';

  bar.innerHTML = html;
  bar.style.display = '';
})();

// ── Header nav dropdown ────────────────────────────────────
(function() {
  var btn = document.querySelector('.header-nav-drop__btn');
  var wrap = document.querySelector('.header-nav-drop');
  if (!btn || !wrap) return;
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    var open = wrap.classList.toggle('is-open');
    btn.classList.toggle('is-active', open);
    btn.setAttribute('aria-expanded', open);
    wrap.querySelector('.header-nav-drop__panel').setAttribute('aria-hidden', !open);
  });
  document.addEventListener('click', function() {
    wrap.classList.remove('is-open');
    btn.classList.remove('is-active');
    btn.setAttribute('aria-expanded', 'false');
    wrap.querySelector('.header-nav-drop__panel').setAttribute('aria-hidden', 'true');
  });
})();

// ── Favorites (wishlist) — localStorage, no account required ──
(function () {
  const STORAGE_KEY = 'vizvoice:favorites';

  function getFavorites() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(stored) ? stored : [];
    } catch (e) {
      return [];
    }
  }

  function setFavorites(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    updateBadge();
  }

  function toggleFavorite(handle) {
    const favorites = getFavorites();
    const idx = favorites.indexOf(handle);
    if (idx >= 0) {
      favorites.splice(idx, 1);
    } else {
      favorites.push(handle);
    }
    setFavorites(favorites);
    return idx < 0;
  }

  function updateBadge() {
    const badge = document.getElementById('favorites-count');
    if (!badge) return;
    const count = getFavorites().length;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function syncButtons() {
    const favorites = getFavorites();
    document.querySelectorAll('[data-favorite-toggle]').forEach(btn => {
      const active = favorites.indexOf(btn.dataset.productHandle) >= 0;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-favorite-toggle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    if (!handle) return;
    const nowActive = toggleFavorite(handle);
    document.querySelectorAll('[data-favorite-toggle][data-product-handle="' + CSS.escape(handle) + '"]').forEach(el => {
      el.classList.toggle('is-active', nowActive);
      el.setAttribute('aria-pressed', String(nowActive));
    });
  });

  updateBadge();
  syncButtons();

  window.VizvoiceFavorites = { getFavorites: getFavorites, toggleFavorite: toggleFavorite };
})();

// ── Quick Add (color + size popover on product cards) ─────
(function () {
  const productCache = new Map();

  function fetchProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch('/products/' + handle + '.js').then(r => r.json()));
    }
    return productCache.get(handle);
  }

  function closeAllPanels() {
    document.querySelectorAll('[data-quick-add-panel].is-open').forEach(panel => {
      panel.classList.remove('is-open');
      panel.hidden = true;
    });
  }

  function updateCartCount() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const cartLink = document.getElementById('header-cart-link');
      if (!cartLink) return;
      let badge = cartLink.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.setAttribute('aria-hidden', 'true');
          cartLink.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    }).catch(() => {});
  }

  function addToCart(variantId, panel) {
    panel.innerHTML = '<p class="quick-add-panel__loading">…</p>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(() => {
        updateCartCount();
        panel.innerHTML = '<p class="quick-add-panel__feedback is-success">Added ✓</p>';
        setTimeout(() => { panel.classList.remove('is-open'); panel.hidden = true; }, 1200);
      })
      .catch(() => {
        panel.innerHTML = '<p class="quick-add-panel__error">Could not add — try again</p>';
      });
  }

  function buildPanel(panel, product) {
    const variants = product.variants;
    const options  = product.options || [];
    const colorIdx = options.findIndex(o => /^colou?r$/i.test(o.name));
    const sizeIdx  = options.findIndex(o => /^size$/i.test(o.name));
    const optKey   = i => 'option' + (i + 1);

    if (variants.length === 1) {
      addToCart(variants[0].id, panel);
      return;
    }

    let selectedColor = null;
    panel.innerHTML = '';

    const colorsWrap = document.createElement('div');
    colorsWrap.className = 'quick-add-panel__colors';
    const sizesWrap = document.createElement('div');
    sizesWrap.className = 'quick-add-panel__sizes';

    function renderSizes() {
      sizesWrap.innerHTML = '';
      if (sizeIdx < 0) return;
      const sizes = [...new Set(variants.map(v => v[optKey(sizeIdx)]))];
      sizes.forEach(size => {
        const v = colorIdx < 0
          ? variants.find(vv => vv[optKey(sizeIdx)] === size)
          : variants.find(vv => vv[optKey(colorIdx)] === selectedColor && vv[optKey(sizeIdx)] === size);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-btn';
        btn.textContent = size;
        btn.disabled = !v || !v.available;
        btn.addEventListener('click', () => addToCart(v.id, panel));
        sizesWrap.appendChild(btn);
      });
    }

    if (colorIdx >= 0) {
      const colors = [...new Set(variants.map(v => v[optKey(colorIdx)]))];
      colors.forEach((color, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'color-swatch' + (i === 0 ? ' is-active' : '');
        btn.title = color;
        btn.setAttribute('aria-label', color);
        const hex = swatchColor(color);
        btn.style.cssText = 'background:' + hex + ';border:' + (hex === '#ffffff' ? '1px solid rgba(0,0,0,.2)' : '1px solid rgba(0,0,0,.08)') + ';';
        btn.addEventListener('click', () => {
          selectedColor = color;
          colorsWrap.querySelectorAll('.color-swatch').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (sizeIdx < 0) {
            const v = variants.find(vv => vv[optKey(colorIdx)] === color);
            if (v) addToCart(v.id, panel);
          } else {
            renderSizes();
          }
        });
        colorsWrap.appendChild(btn);
      });
      selectedColor = colors[0];
      panel.appendChild(colorsWrap);
    }

    renderSizes();
    if (sizeIdx >= 0) panel.appendChild(sizesWrap);
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-quick-add-trigger]');
    if (trigger) {
      e.preventDefault();
      const wrap = trigger.closest('.quick-add');
      const panel = wrap ? wrap.querySelector('[data-quick-add-panel]') : null;
      const handle = trigger.dataset.productHandle;
      if (!handle || !panel) return;

      const wasOpen = panel.classList.contains('is-open');
      closeAllPanels();
      if (wasOpen) return;

      panel.hidden = false;
      panel.classList.add('is-open');
      panel.innerHTML = '<p class="quick-add-panel__loading">…</p>';

      fetchProduct(handle).then(product => {
        if (!panel.classList.contains('is-open')) return;
        buildPanel(panel, product);
      }).catch(() => {
        panel.innerHTML = '<p class="quick-add-panel__error">Something went wrong</p>';
      });
      return;
    }

    if (!e.target.closest('[data-quick-add-panel]')) {
      closeAllPanels();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });
})();

// ── Image lazy load ────────────────────────────────────────
if ('loading' in HTMLImageElement.prototype) {
  document.querySelectorAll('img[data-src]').forEach(img => {
    img.src = img.dataset.src;
  });
} else {
  // Fallback: load all immediately
  document.querySelectorAll('img[data-src]').forEach(img => {
    img.src = img.dataset.src;
  });
}
